import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

export function getTransportOrderEventTranslationKey(
	event: Enums<"transportOrderEvent">,
): TranslationKey {
	switch (event) {
		case "raised":
			return "stock.transport_event.raised";
		case "picked-up":
			return "stock.transport_event.picked_up";
		case "taken-over":
			return "stock.transport_event.taken_over";
		case "delivered":
			return "stock.transport_event.delivered";
		case "canceled":
			return "stock.transport_event.canceled";
	}
}
